export const termsAndConditions = {
    heading: 'terms-and-conditions-page-heading',
    sectionHeading: 'terms-and-conditions-page-heading',
    sectionBody: 'terms-and-conditions-page-body',
}